import { useStorage } from '@vueuse/core'

const DEFAULT_VALUE = {
  code: '',
}

export const useDiscountStorage = () => {
  const globalStore = useGlobalStore()

  const discountStorage = useStorage(`STOREFRONT_DISCOUNTS::${globalStore.store.id}`, {
    ...DEFAULT_VALUE,
  })

  const empty = () => {
    discountStorage.value = { ...DEFAULT_VALUE }
  }

  return { discountStorage, empty }
}
